
export enum AuthAccessLogicalType {
    And, 
    Or
}